import { Component, EventEmitter, Input, OnInit, Output, OnChanges } from '@angular/core';

@Component({
  selector: 'app-advanced-search-sort-drop-down',
  templateUrl: './advanced-search-sort-drop-down.component.html',
  styleUrls: ['./advanced-search-sort-drop-down.component.scss']
})

export class AdvancedSearchSortDropDownComponent implements OnInit {
  @Output() sortChanged = new EventEmitter<{ sortOption: string; sortOrder: 'Ascending' | 'Descending' }>();
  @Input() defaultSortOrder: 'Ascending' | 'Descending';
  @Input() defaultSortOption: string;
  @Input() isFilterdJobListAvailable: boolean;
  selectedSortOrder: 'Ascending' | 'Descending';
  selectedSortOption: string;

  constructor() { }

  ngOnChanges() {
    if (!this.isFilterdJobListAvailable) {      
      this.selectedSortOption = 'Posted Date';
      this.selectedSortOrder = 'Descending';
    }
  }

  ngOnInit(): void {
    this.selectedSortOrder = this.defaultSortOrder; 
          
      switch(this.defaultSortOption){
        case 'Name': {
          this.selectedSortOption = 'Job Title';
          break;
        }
        case 'JobNumber':{
          this.selectedSortOption = 'Job ID'
          break;
        }
        case 'Address':{
          this.selectedSortOption = 'Property Address'
          break;
        }
        case 'JobStatusDescription':{
          this.selectedSortOption = 'Status'
          break;
        }
        case 'ServiceType':{
          this.selectedSortOption = 'Service Type'
          break;
        }
        case 'PostedDate':{
          this.selectedSortOption = 'Posted Date'
          break;
        }
        case 'ServiceProviderName':{
          this.selectedSortOption = 'Service Provider'
          break;
        }
        case 'AssignedPM':{
          this.selectedSortOption = 'Property Manager'
          break;
        }
        case 'Deadline':{
          this.selectedSortOption = 'Deadline'
          break;
        }
      };
    
  }

  showDropdown = false;

  sortOptions = [
    'Job Title',
    'Job ID',
    'Property Address',
    'Status',
    'Service Type',
    'Posted Date',
    'Service Provider',
    'Property Manager',
    'Deadline'
  ];

  toggleDropdown() {
    this.showDropdown = !this.showDropdown;
  }

  onSortOptionChange(option: string) {
    this.selectedSortOption = option;
    this.emitSortChange();
  } 

  onSortOrderChange(order: 'Ascending' | 'Descending') {
    this.selectedSortOrder = order;
    this.emitSortChange();
  }

  private emitSortChange() {
    this.sortChanged.emit({
      sortOption: this.selectedSortOption,
      sortOrder: this.selectedSortOrder,
    });
  }

}
